document.body.addEventListener('click', function(e) {
  // 检查点击目标是否是.des_title下的a标签
  const targetLink = e.target.closest('.des_title a');
  if (!targetLink) return; // 不是目标元素则退出

  // 获取相关元素
  const selfTitle = targetLink.parentElement; // .des_title元素
  const container = selfTitle.parentElement; // 共同父容器
  const selfContent = container.querySelector('.des_content'); // 对应的内容元素

  // 检查内容是否隐藏
  const isHidden = getComputedStyle(selfContent).display === 'none';

  if (isHidden) {
    // 展开逻辑
    selfTitle.classList.add('active');
    // 显示动画（500ms）
    selfContent.style.transition = 'all 500ms ease';
    selfContent.style.display = 'block';
    // 触发重排后设置高度相关样式（确保动画生效）
    setTimeout(() => {
      selfContent.style.opacity = '1';
      selfContent.style.maxHeight = selfContent.scrollHeight + 'px';
    }, 10);
  } else {
    // 折叠逻辑
    selfTitle.classList.remove('active');
    // 隐藏动画（500ms）
    selfContent.style.transition = 'all 500ms ease';
    selfContent.style.opacity = '0';
    selfContent.style.maxHeight = '0';
    // 动画结束后隐藏元素
    setTimeout(() => {
      selfContent.style.display = 'none';
    }, 500);
  }
});
// 1. 获取所有 .des_content 下的 table 元素
const des_contenttables = document.querySelectorAll(".des_content table");

// 2. 核心判断：只有存在表格元素时才执行后续操作
if (des_contenttables.length > 0) {
  // 3. 遍历每个表格（用 for 循环保证最大兼容性，比如旧版浏览器）
  for (let i = 0; i < des_contenttables.length; i++) {
    const table = des_contenttables[i];
    
    // 4. 创建包裹用的 div 容器
    const wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper'; // 给容器添加类名
    
    // 5. 替换 DOM 节点：把表格替换成容器，再把表格放入容器内
    table.parentNode.replaceChild(wrapper, table);
    wrapper.appendChild(table);
  }
}